import { PageRoute } from "..";
import { values } from "lodash";
import { FC } from "react";
import { useDispatch } from "react-redux";
import { Route, Switch } from "react-router-dom";

import Redirect from "components/Redirect";
import { GridColumnType } from "components/grid";
import { TicketsRoutes, getPathForRoute } from "constants/tickets/TicketsRoutes";
import { withRememberLastRoute } from "routes/withRememberLastRoute";
import { TicketsViewActions } from "store/views/tickets/actions";

import { RedirectTicketToTextApp } from "./RedirectTicketToTextApp";
import { TicketsGrid } from "./TicketsGrid";
import { Ticket } from "./ticket";
import { TicketAdd } from "./ticket-add/TicketAdd";

const routes = values(TicketsRoutes).map(route => getPathForRoute(route));

const Router: FC = () => {
  const dispatch = useDispatch();
  const redirectToAll = <Redirect to={getPathForRoute(TicketsRoutes.All)} />;

  return (
    <Switch>
      <Route
        exact
        path="/tickets"
        render={() => {
          dispatch(TicketsViewActions.setFocusedColumn(GridColumnType.Second));
          return redirectToAll;
        }}
      />
      <PageRoute path="/tickets/add" documentTitle="New ticket" component={TicketAdd} />
      <Route exact path="/tickets/dashboard" render={() => redirectToAll} />
      <Route exact path={routes}>
        <TicketsGrid />
      </Route>
      <Route
        exact
        path="/tickets/:ticketId?"
        render={props =>
          props.match.params.ticketId ? (
            <RedirectTicketToTextApp id={props.match.params.ticketId}>
              <Ticket id={props.match.params.ticketId} />
            </RedirectTicketToTextApp>
          ) : (
            redirectToAll
          )
        }
      />
    </Switch>
  );
};

export default withRememberLastRoute(Router, "/tickets");
